import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { News_News_$reflection, News_NewsListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Loaded, request, postEmpty } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { Remote$1 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { value } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { AllNewsModel, Msg, Model, NewsItemModel } from "./Types.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";

export function Http_getNewsPage(page) {
    const response = fetch(toText(printf("/api/news?page=%i"))(page), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Paginated$1_$reflection(News_NewsListItem_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getNews(id) {
    let arg;
    const response = fetch((arg = encodeURIComponent(id), toText(printf("/api/news/%s"))(arg)), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(News_News_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_imageUrl(id) {
    const arg = encodeURIComponent(id);
    return toText(printf("/api/news/%s/image"))(arg);
}

export function Http_markRead(id) {
    let arg;
    return postEmpty((arg = encodeURIComponent(id), toText(printf("/api/news/%s/isshown"))(arg)));
}

export function State_init(page, user, lastModel) {
    let m_1;
    if (page.tag === 1) {
        const id = page.fields[0];
        return [new Model(1, [new NewsItemModel(id, new Remote$1(1, []), (lastModel != null) ? ((lastModel.tag === 0) ? ((lastModel.fields[0].PageNumber != null) ? ((m_1 = lastModel.fields[0], value(m_1.PageNumber))) : 1) : 1) : 1)]), singleton((dispatch_1) => {
            dispatch_1(new Msg(1, [id]));
        })];
    }
    else {
        const pagenumber = page.fields[0] | 0;
        return [new Model(0, [new AllNewsModel(pagenumber, new Remote$1(1, []))]), singleton((dispatch) => {
            dispatch(new Msg(0, [pagenumber]));
        })];
    }
}

export function State_update(msg, model) {
    let matchResult, page, submodel, id, model_1, submodel_1, x, submodel_2, x_1, id_2;
    switch (msg.tag) {
        case 1: {
            matchResult = 1;
            id = msg.fields[0];
            model_1 = model;
            break;
        }
        case 2: {
            if (model.tag === 0) {
                matchResult = 2;
                submodel_1 = model.fields[0];
                x = msg.fields[0];
            }
            else {
                matchResult = 6;
            }
            break;
        }
        case 3: {
            if (model.tag === 1) {
                matchResult = 3;
                submodel_2 = model.fields[0];
                x_1 = msg.fields[0];
            }
            else {
                matchResult = 6;
            }
            break;
        }
        case 4: {
            matchResult = 4;
            id_2 = msg.fields[0];
            break;
        }
        case 5: {
            matchResult = 5;
            break;
        }
        default:
            if (model.tag === 0) {
                matchResult = 0;
                page = msg.fields[0];
                submodel = model.fields[0];
            }
            else {
                matchResult = 6;
            }
    }
    switch (matchResult) {
        case 0:
            return [new Model(0, [new AllNewsModel(submodel.PageNumber, new Remote$1(1, []))]), request(Http_getNewsPage, page, (Item) => (new Msg(2, [Item])))];
        case 1: {
            const loadNewsCmd = request(Http_getNews, id, (Item_2) => (new Msg(3, [Item_2])));
            return [new Model(1, [new NewsItemModel(id, new Remote$1(1, []), (model_1.tag === 1) ? model_1.fields[0].BackToPage : ((model_1.fields[0].PageNumber != null) ? value(model_1.fields[0].PageNumber) : 1))]), loadNewsCmd];
        }
        case 2:
            return [new Model(0, [new AllNewsModel(submodel_1.PageNumber, Loaded(x))]), Cmd_none()];
        case 3: {
            const cmd = (x_1.tag === 0) ? singleton((dispatch) => {
                dispatch(new Msg(4, [submodel_2.Id]));
            }) : Cmd_none();
            return [new Model(1, [new NewsItemModel(submodel_2.Id, Loaded(x_1), submodel_2.BackToPage)]), cmd];
        }
        case 4:
            return [model, request(Http_markRead, id_2, (Item_5) => (new Msg(5, [Item_5])))];
        case 5:
            return [model, Cmd_none()];
        default: {
            return [model, Cmd_none()];
        }
    }
}

//# sourceMappingURL=State.fs.js.map
